class MoneyUtil {
  static formatCurrency(value) {
    return `${value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'} )}`; // { minimumFractionDigits: 2 }
  }
}

export default MoneyUtil;
